<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本id" prop="scriptId" >
        <a-input v-model="form.scriptId" placeholder="请输入剧本id" />
      </a-form-model-item>
      <a-form-model-item label="店铺id" prop="shopId" >
        <a-input v-model="form.shopId" placeholder="请输入店铺id" />
      </a-form-model-item>
      <a-form-model-item label="订单id" prop="orderId" >
        <a-input v-model="form.orderId" placeholder="请输入订单id" />
      </a-form-model-item>
      <a-form-model-item label="剧本编码" prop="scriptCode" >
        <a-input v-model="form.scriptCode" placeholder="请输入剧本编码" />
      </a-form-model-item>
      <a-form-model-item label="剧本类型 1.常规 2.冬季特辑 3.···" prop="scriptType" >
      </a-form-model-item>
      <a-form-model-item label="开本类型 1.真实 2.模拟" prop="playedType" >
      </a-form-model-item>
      <a-form-model-item label="支付方式 1.优惠券门票 2.元宝支付 3.微信支付" prop="payChannel" >
        <a-input v-model="form.payChannel" placeholder="请输入支付方式 1.优惠券门票 2.元宝支付 3.微信支付" />
      </a-form-model-item>
      <a-form-model-item label="使用的优惠券id" prop="useCouponId" >
        <a-input v-model="form.useCouponId" placeholder="请输入使用的优惠券id" />
      </a-form-model-item>
      <a-form-model-item label="是否使用测试优惠券 0.否 1.是" prop="isTestCoupon" >
        <a-input v-model="form.isTestCoupon" placeholder="请输入是否使用测试优惠券 0.否 1.是" />
      </a-form-model-item>
      <a-form-model-item label="订单总金额" prop="orderAmount" >
        <a-input v-model="form.orderAmount" placeholder="请输入订单总金额" />
      </a-form-model-item>
      <a-form-model-item label="实际订单价格" prop="payPrice" >
        <a-input v-model="form.payPrice" placeholder="请输入实际订单价格" />
      </a-form-model-item>
      <a-form-model-item label="折扣金额" prop="discountAmount" >
        <a-input v-model="form.discountAmount" placeholder="请输入折扣金额" />
      </a-form-model-item>
      <a-form-model-item label="使用元宝数" prop="payIngot" >
        <a-input v-model="form.payIngot" placeholder="请输入使用元宝数" />
      </a-form-model-item>
      <a-form-model-item label="状态 0.未支付 1.已开本 2.已结束" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="开始时间" prop="startTime" >
        <a-date-picker style="width: 100%" v-model="form.startTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="结束时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" >
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="version" >
        <a-input v-model="form.version" placeholder="请输入版本号" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getScriptShopOpen, addScriptShopOpen, updateScriptShopOpen } from '@/api/played/scriptShopOpen'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        scriptId: null,
        shopId: null,
        orderId: null,
        scriptCode: null,
        scriptType: null,
        playedType: null,
        payChannel: null,
        useCouponId: null,
        isTestCoupon: null,
        orderAmount: null,
        payPrice: null,
        discountAmount: null,
        payIngot: null,
        status: 0,
        startTime: null,
        endTime: null,
        createTime: null,
        creator: null,
        updateTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scriptId: [
          { required: true, message: '剧本id不能为空', trigger: 'blur' }
        ],
        shopId: [
          { required: true, message: '店铺id不能为空', trigger: 'blur' }
        ],
        scriptCode: [
          { required: true, message: '剧本编码不能为空', trigger: 'blur' }
        ],
        scriptType: [
          { required: true, message: '剧本类型 1.常规 2.冬季特辑 3.···不能为空', trigger: 'change' }
        ],
        playedType: [
          { required: true, message: '开本类型 1.真实 2.模拟不能为空', trigger: 'change' }
        ],
        payChannel: [
          { required: true, message: '支付方式 1.优惠券门票 2.元宝支付 3.微信支付不能为空', trigger: 'blur' }
        ],
        useCouponId: [
          { required: true, message: '使用的优惠券id不能为空', trigger: 'blur' }
        ],
        isTestCoupon: [
          { required: true, message: '是否使用测试优惠券 0.否 1.是不能为空', trigger: 'blur' }
        ],
        orderAmount: [
          { required: true, message: '订单总金额不能为空', trigger: 'blur' }
        ],
        payPrice: [
          { required: true, message: '实际订单价格不能为空', trigger: 'blur' }
        ],
        discountAmount: [
          { required: true, message: '折扣金额不能为空', trigger: 'blur' }
        ],
        payIngot: [
          { required: true, message: '使用元宝数不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0.未支付 1.已开本 2.已结束不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记 1:删除,0:未删除不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        scriptId: null,
        shopId: null,
        orderId: null,
        scriptCode: null,
        scriptType: null,
        playedType: null,
        payChannel: null,
        useCouponId: null,
        isTestCoupon: null,
        orderAmount: null,
        payPrice: null,
        discountAmount: null,
        payIngot: null,
        status: 0,
        startTime: null,
        endTime: null,
        createTime: null,
        creator: null,
        updateTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getScriptShopOpen(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateScriptShopOpen(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addScriptShopOpen(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
